import { jsxs as n, jsx as e, Fragment as b } from "react/jsx-runtime";
import { FieldLabel as y, FieldErrorAndDescription as N } from "@systemeio/ui";
import { SuccessIcon as w } from "@systemeio/ui/icons";
import { twMerge as l, twJoin as k } from "tailwind-merge";
const I = ({
  options: t,
  selected: a,
  onChange: s,
  disabled: i,
  error: c,
  label: d,
  required: m,
  className: o,
  labelClassName: p,
  optionsWrapperClassName: f,
  optionWrapperClassName: x,
  selectedOptionWrapperClassName: u,
  optionClassName: h,
  selectedOptionClassName: g
}) => /* @__PURE__ */ n("div", { className: l("flex flex-col gap-1", o), children: [
  /* @__PURE__ */ e(y, { label: d, labelClassName: p, required: m }),
  /* @__PURE__ */ e("ul", { className: l("flex flex-col gap-5", f), children: t ? t.map((r) => /* @__PURE__ */ n(
    "li",
    {
      className: l(
        x,
        r.id === a && u,
        "border-text-secondary/30 rounded-lg border"
      ),
      children: [
        /* @__PURE__ */ n(
          "label",
          {
            className: l(
              "relative flex items-center gap-2",
              !i && "cursor-pointer",
              "p-4"
            ),
            children: [
              /* @__PURE__ */ e(
                "input",
                {
                  className: l(
                    "border-2 outline-hidden",
                    i ? "border-fill-primary/70" : "border-fill-primary",
                    "h-[20px] w-[20px] rounded-full",
                    r.id === a ? "bg-background-secondary" : "bg-transparent",
                    "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
                  ),
                  disabled: i,
                  checked: r.id === a,
                  value: r.caption,
                  onChange: () => s(r.id),
                  type: "radio"
                }
              ),
              /* @__PURE__ */ e(
                w,
                {
                  className: k(
                    "absolute",
                    r.id !== a && "fill-transparent",
                    i && "opacity-70"
                  )
                }
              ),
              /* @__PURE__ */ n("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: [
                /* @__PURE__ */ e(
                  "span",
                  {
                    className: l(
                      "main-transition-colors",
                      r.id === a ? "text-text-primary" : "text-text-primary/50",
                      i && "opacity-70",
                      h,
                      r.id === a ? g : void 0,
                      "text-left"
                    ),
                    children: r.caption
                  }
                ),
                r.additionalInfo
              ] })
            ]
          }
        ),
        r.content && r.id === a && /* @__PURE__ */ e("div", { className: "px-4 pb-4", children: r.content })
      ]
    },
    r.id
  )) : /* @__PURE__ */ n(b, { children: [
    /* @__PURE__ */ e(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ e(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ e(N, { error: c })
] });
export {
  I as default
};
